import { JOB_SEARCH } from '@/page/constants'

export const DEFAULT_TYPE = JOB_SEARCH

export default {
  type: DEFAULT_TYPE
}
